import React from 'react';
import { useTranslation } from 'react-i18next';

import { useParseDate } from 'hooks';

import UserAvatar from 'core/components/user/avatar/UserAvatar';
import * as Styled from './StyledContract';

export function ContractCard(props) {
    const { t } = useTranslation('ranking');
    const data = props.data || props.relationship || undefined;
    const { company } = data;
    const contractPeriod = useParseDate({ startDate: data.startDate, endDate: data.endDate });

    // const { postStartupContractValidationEmail } = useRankingStartup({ startupId: });

    const bold = data.companyContact.name;
    const text = `${contractPeriod.formattedDate.formattedStartDate.mm} ${contractPeriod.formattedDate.formattedStartDate.yyyy} - ${contractPeriod.formattedDate.formattedEndDate.mm} ${contractPeriod.formattedDate.formattedEndDate.yyyy}`;

    const propsCard = {
        as: data.onClick ? 'button' : undefined,
        onClick: data.onClick,
    };

    data.displayAudit = true;

    const badges = [];

    if (data.audited && data.status && data.status === 'confirmed' && data.displayAudit === true) {
        if (data.audited === 'confirmed') {
            const cn = 'badge badge-success mr-2';
            badges.push(() => <div className={cn}>{t('auditConfirmed')}</div>);
        }
        if (data.audited === 'rejected') {
            const cn = 'badge badge-danger mr-2';
            badges.push(() => <div className={cn}>{t('auditRejected')}</div>);
        }
    }
    if (data.status === 'confirmed' && data.audited !== 'pending' && data.displayAudit) {
        if (data.reconsiderationResult) {
            let cn = 'badge badge-secondary';
            badges.push(() => <div className={cn}>{t('reconsiderationDone')}</div>);
        } else if (data.reconsiderations && data.reconsiderations.length > 0) {
            const cn = 'badge badge-warning';
            badges.push(() => <div className={cn}>{t('reconsiderationRequested')}</div>);
        }
    }

    const sideBadges = [];
    if (data.invalid && data.outOfRange) {
        const cn = 'badge badge-danger mr-2';
        sideBadges.push(() => <div className={cn}>{t('contractOutOfRange')}</div>);
    }
    if (data.invalid && data.expired) {
        const cn = 'badge badge-danger mr-2';
        sideBadges.push(() => <div className={cn}>{t('contractExpired')}</div>);
    }

    return (
        <Styled.ContractCard {...propsCard}>
            <UserAvatar user={{ firstName: company.name, photoUrl: company.logoUrl }} />
            <Styled.CardInfos>
                <span className="name">{company.name}</span>
                <span className="bold">{bold}</span>
                <span className="text">{text}</span>
                {!!data.onClick && data.status === 'pending' && (
                    <Styled.ResendInfo>{t('glossary:resendInfo')}</Styled.ResendInfo>
                )}
                {!props.fromContract && badges.map((BadgeEl, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <BadgeEl key={`badge-${k}`} />
                ))}
                {sideBadges.map((Badge, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Badge key={`sidebadge-${k}`} />
                ))}
            </Styled.CardInfos>
            
        </Styled.ContractCard>
    );
}
export default ContractCard;
